import { render, staticRenderFns } from "./ActivitiesPage.vue?vue&type=template&id=c9827650&"
import script from "./ActivitiesPage.vue?vue&type=script&lang=js&"
export * from "./ActivitiesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports